<template>
  <main-layout>
	<section role="main" aria-label="תוכן" class="content">
			<div class="divider"></div>
			<div id="team" class="info-content">
				<div class="fill">
					<img :key=img2srcD :src=img2srcD alt="מי אנחנו" class="fillImgBack" >
				<transition name="fade" mode="out-in">
					<img :key=img2src :src=img2src alt="מי אנחנו" class="fillImgFront" >
				</transition>
				</div>
				<div class="textbox-bounds textbox-bounds">
					<div class="textbox-flex">
						<div class="textbox-tab-mark"></div>
						</br>
						<!-- managment section -->
						<div class="memberFlex">
							<TeamMember v-for="member in texts.managment" :parentComp="roundRef"
										:memberName="member.membername"
										:title="member.title"
										:picture="member.picture"
										:song="member.song"
										:info="member.info"/>
						</div>
						
						<!-- צוות החצר-צפון -->
						<div class="textbox-tab-mark"></div>
						</br>
						<div class="textbox-text">
							<div class="text-box-paragraph">
								<h3>צוות החצר-צפון</h3>
							</div>
						</div>
						
						<!-- managment2_north -->
						<div class="textbox-text">
							<div class="text-box-paragraph">
								<h4>צוות מקצועי</h4>
							</div>
						</div>
						<div class="memberFlex">
							<TeamMember v-for="member in texts.managment2_north" :parentComp="roundRef"
										:memberName="member.membername"
										:title="member.title"
										:picture="member.picture"
										:song="member.song"
										:info="member.info"/>
						</div>
						
						<!-- members_north -->
						<div class="memberFlex">
							<TeamMember v-for="member in texts.members_north" :parentComp="roundRef"
										:memberName="member.membername"
										:title="member.title"
										:picture="member.picture"
										:song="member.song"
										:info="member.info"/>
						</div>
						
						<!-- office_north -->
						<div class="textbox-text">
							<div class="text-box-paragraph">
								<h4>משרד</h4>
							</div>
						</div>
						<div class="memberFlex">
							<TeamMember v-for="member in texts.office_north" :parentComp="roundRef"
										:memberName="member.membername"
										:title="member.title"
										:picture="member.picture"
										:song="member.song"
										:info="member.info"/>
						</div>
					</div>
				</div>
			</div>
		<div class="divider"></div>

			<div class="info-content">
				<div class="fill">
					<img :key=img3srcD :src=img3srcD alt="מי אנחנו" class="fillImgBack" >
					<transition name="fade" mode="out-in">
						<img :key=img3src :src=img3src alt="מי אנחנו" class="fillImgFront" >
					</transition>
				</div>
				<div class="textbox-bounds textbox-bounds">
					<div class="textbox-flex">
						<!-- צוות החצר-מרכז -->
						<div class="textbox-tab-mark"></div>
						</br>
						<div class="textbox-text">
							<div class="text-box-paragraph">
								<h3>צוות החצר-מרכז</h3>
							</div>
						</div>
						
						<!-- managment2 -->
						<div class="textbox-text">
							<div class="text-box-paragraph">
								<h4>צוות מקצועי</h4>
							</div>
						</div>
						<div class="memberFlex">
							<TeamMember v-for="member in texts.managment2" :parentComp="roundRef"
										:memberName="member.membername"
										:title="member.title"
										:picture="member.picture"
										:song="member.song"
										:info="member.info"/>
						</div>
						
						<!-- members -->
						<div class="memberFlex">
							<TeamMember v-for="member in texts.members" :parentComp="roundRef"
										:memberName="member.membername"
										:title="member.title"
										:picture="member.picture"
										:song="member.song"
										:info="member.info"/>
						</div>
						
						<!-- office -->
						<div class="textbox-text">
							<div class="text-box-paragraph">
								<h4>משרד</h4>
							</div>
						</div>
						<div class="memberFlex">
							<TeamMember v-for="member in texts.office" :parentComp="roundRef"
										:memberName="member.membername"
										:title="member.title"
										:picture="member.picture"
										:song="member.song"
										:info="member.info"/>
						</div>
						
						<!-- founder - at the end -->
						<div class="textbox-tab-mark"></div>
						</br>
						<div class="textbox-text">
							<div class="text-box-paragraph">
								<h3>מייסד</h3>
							</div>
						</div>
						<div class="memberFlex">
							<TeamMember v-for="member in texts.founder" :parentComp="roundRef"
										:memberName="member.membername"
										:title="member.title"
										:picture="member.picture"
										:song="member.song"
										:info="member.info"/>
						</div>
					</div>
				</div>
			</div>


			<div class="divider"></div>
			<div id="FAQS" class="info-content double-content2">
				<div class="fill double-content2">
					<img :key=img8srcD :src=img8srcD alt="מי אנחנו" class="fillImgBack" >
					<transition name="fade" mode="out-in">
						<img :key=img8src :src=img8src alt="מי אנחנו" class="fillImgFront" >
					</transition>
				</div>
				<div class="textbox-bounds double-textbounds">
				<div class="textbox textbox-right">
					<div class="textbox-tab-mark"></div>
					<div class="textbox-text">
						<div class="text-box-paragraph">
							<h3>שאלות נפוצות</h3>

							<transition name="fade" mode="out-in">
						<FAQ :key="faq"></FAQ>
					</transition>
						</div>
					</div>
				</div>
			</div>
		</div>


		</section>
<TeamMemberInfo :memberName='memberName' :title='title' :info='info' :picture='picture' :song='song' v-if="showInfo" @close="showInfo = false"></TeamMemberInfo>
  </main-layout>
</template>

<script>
var APIbase = "https://yard-bands.herokuapp.com"
import axios from 'axios'
  import MainLayout from '../layouts/Main.vue'
   import VLink from '../components/VLink.vue'
   import TeamMember from '../components/TeamMember.vue'
   import FAQ from '../components/FAQ.vue'
   import TeamMemberInfo from '../components/TeamMemberInfo.vue'
  export default {
    components: {
      MainLayout,FAQ,VLink,TeamMember,TeamMemberInfo
    },
	created () {
		this.auditionButtonOpen=false;
		this.img2src = this.img2List[Math.floor(Math.random() * this.img2List.length)]
		this.img3src = this.img3List[Math.floor(Math.random() * this.img3List.length)]
		this.img5src = this.img5List[Math.floor(Math.random() * this.img5List.length)]
		this.img6src = this.img6List[Math.floor(Math.random() * this.img6List.length)]
		//this.img7src = list[Math.floor(Math.random() * list.length)]
		//this.img8src = list[Math.floor(Math.random() * list.length)]
		this.img2srcD=""+this.img2src
	    this.img3srcD=""+this.img3src
	    this.img5srcD=""+this.img5src
		this.img6srcD=""+this.img6src
	    this.img7srcD=""+this.img7src
	    this.img8srcD=""+this.img8src
		this.SetImgInterval("img2src",this.img2List,0)
		this.SetImgInterval("img3src",this.img3List,10000)
		this.SetImgInterval("img5src",this.img5List,15000)
		this.SetImgInterval("img6src",this.img6List,25000)
		this.texts = {}
		this.roundRef = this
		this.fetchTeamLabels()
	},
	data() {
		return {
			img2srcD:'',
			img3srcD:'',
			img5srcD:'',
			img6srcD:'',
			img7srcD:'',
			img8srcD:'',
			img2src: 'photos/container02/c02_01.jpg',
			img3src: 'photos/container03/c03_01.jpg',
			img5src: 'photos/container05/c05_01.jpg',
			img6src: 'photos/container06/c06_01.jpg',
			img7src: 'photos/container07/c07_01.jpg',
			img8src: 'photos/container08/c08_01.jpg',
			img2List : ["photos/container02/c02_01.jpg","photos/container02/c02_02.jpg","photos/container02/c02_03.jpg","photos/container02/c02_04.jpg","photos/container02/c02_05.jpg","photos/container02/c02_06.jpg","photos/container02/c02_07.jpg"],
			img3List : ["photos/container03/c03_01.jpg","photos/container03/c03_02.jpg","photos/container03/c03_03.jpg","photos/container03/c03_04.jpg"],
			img5List : ["photos/container05/c05_01.jpg","photos/container05/c05_02.jpg"],
			img6List : ["photos/container06/c06_01.jpg","photos/container06/c06_02.jpg"],
			showInfo : false,
			memberName: '',
			title:'',
			picture:'',
			song:''
		}
	},
	watch: {
		showInfo: function (val) {
			console.log("showInfoChanges")
			if (val) {
				document.body.classList.add('modal-open');
				document.getElementById("headerC").classList.add('background-modal');
				document.getElementById("content-wrapper").classList.add('background-modal-wrapper');
			}
			else {
				document.body.classList.remove('modal-open');
				document.getElementById("headerC").classList.remove('background-modal');
				document.getElementById("content-wrapper").classList.remove('background-modal-wrapper');
			}
		}
	},
	methods: {
		SetImgInterval(imgID,list,offset) {
			if (offset > 0) {
				setTimeout(function() {
					this.SetImgInterval(imgID,list,0)
				}.bind(this),offset);
			}
			else {
				setInterval(function(){
					var tmp = new Image();
					var newsrc = list[((list.indexOf(this[imgID]) + 1) % list.length)];
					tmp.src = newsrc
					tmp.onload = function(event) {
						this[imgID] = newsrc;
						setTimeout(function() {
							this[imgID+"D"] = newsrc;
						}.bind(this),5000);
					}.bind(this);

				}.bind(this), 30000);
			}
		},
		toggleAudition() {
			this.auditionButtonOpen = !this.auditionButtonOpen
			this.$forceUpdate();
		},
		showTeamMemberInfo(caller,NmemberName,Ntitle,Ninfo,Npicture,Nsong) {
			caller.memberName = NmemberName;
			caller.title = Ntitle;
			caller.info = Ninfo.replace(/\#/g,'\'').replace(/\$/g,'"');
			caller.picture = Npicture;
			caller.song = Nsong;
			caller.showInfo = true;
		},
		fetchTeamLabels() {
			axios.get(APIbase+'/team_text').then(response => {
				this.texts = response.data;
				this.$forceUpdate();
			})
		}
	}

  }
</script>



// WEBPACK FOOTER //
// Team.vue?55f97e02